module.exports = __webpack_public_path__ + "static/media/promo7.a786043b.jpg";